/* eslint-disable max-len */
import React from 'react';

const CBDVIcon = (props) => (
  <svg width='60' height='38' viewBox='0 0 60 38' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M31.4038 13.0844C32.3489 13.0844 33.0402 12.4073 33.0402 11.4621C33.0402 10.517 32.3489 9.83984 31.4038 9.83984C30.4539 9.83984 29.7627 10.517 29.7627 11.4621C29.7627 12.4073 30.4539 13.0844 31.4038 13.0844ZM31.4038 12.4919C30.8207 12.4919 30.4492 12.0452 30.4492 11.4621C30.4492 10.8743 30.8207 10.4323 31.4038 10.4323C31.9822 10.4323 32.3536 10.8743 32.3536 11.4621C32.3536 12.0452 31.9822 12.4919 31.4038 12.4919Z'
      fill='#4F5D68'
    />
    <path
      d='M36.3301 13.028V9.89157H35.6577V11.1236H34.1765V9.89157H33.5087V13.028H34.1765V11.7066H35.6577V13.028H36.3301Z'
      fill='#4F5D68'
    />
    <path
      d='M14.4554 37.4539V34.2597H13.7706V35.5144H12.2621V34.2597H11.582V37.4539H12.2621V36.1082H13.7706V37.4539H14.4554Z'
      fill='#4F5D68'
    />
    <path
      d='M16.603 37.5114C17.5656 37.5114 18.2695 36.8218 18.2695 35.8592C18.2695 34.8966 17.5656 34.207 16.603 34.207C15.6356 34.207 14.9316 34.8966 14.9316 35.8592C14.9316 36.8218 15.6356 37.5114 16.603 37.5114ZM16.603 36.908C16.0091 36.908 15.6308 36.453 15.6308 35.8592C15.6308 35.2606 16.0091 34.8104 16.603 34.8104C17.192 34.8104 17.5703 35.2606 17.5703 35.8592C17.5703 36.453 17.192 36.908 16.603 36.908Z'
      fill='#4F5D68'
    />
    <path
      d='M22.1811 18.3456V15.0742H21.4797V16.3592H19.9347V15.0742H19.2383V18.3456H19.9347V16.9674H21.4797V18.3456H22.1811Z'
      fill='#4F5D68'
    />
    <path
      d='M5.30605 26.0956V22.8242H4.60469V24.1092H3.05974V22.8242H2.36328V26.0956H3.05974V24.7174H4.60469V26.0956H5.30605Z'
      fill='#4F5D68'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.3877 6.65059L1.7627 10.4006V19.914L8.09138 23.8545L5.26478 29.6086H0.887695V31.6086H5.33875L7.66903 35.2705L9.35636 34.1968L7.03284 30.5455L10.1496 24.2007L16.6243 20.5168L22.5127 24.0498V31.3367L18.8159 33.9132L19.9595 35.554L23.5898 33.0238L31.2961 37.0012L38.0173 33.0183L44.8832 37.013L51.8785 33.0156L58.1279 36.7189L59.1475 34.9984L51.8968 30.7017L44.8922 34.7043L39.0127 31.2835V22.8972L31.6377 18.7722V14.0859H29.6377V18.7821L23.5218 22.3229L17.6377 18.7925V10.375L10.3877 6.62503V0.835938H8.3877V6.65059ZM15.6377 18.7771V11.5923L9.40915 8.37059L3.7627 11.5667V18.8033L9.41075 22.32L15.6377 18.7771ZM24.5127 24.0602V31.2494L31.2293 34.7161L37.0127 31.2888V24.0701L30.6462 20.5092L24.5127 24.0602Z'
      fill='#64737F'
    />
  </svg>
);
export default CBDVIcon;
